// src/app/app.routes.ts

import { Routes } from '@angular/router';
import { authenticationGuard, authorizationGuard, ErrorComponent, WhoamiComponent } from 'shared-frontend';
import { PERMISSION_SETS } from './core/auth/roles.constants';

const loadHome  = () => import('./features/event-submission/pages/homepage/homepage.component').then(m => m.HomepageComponent);
const loadEventSubmissionRoutes = () => import('./features/event-submission/event-submission.routes').then(m => m.EVENT_SUBMISSION_ROUTES)

export const routes: Routes = [
    {
        path: '',
        canActivate: [authenticationGuard], // ← Everything requires authentication
        children: [
            // Default
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'whoami', component: WhoamiComponent }, // Login debug page
            { path: 'home', loadComponent: loadHome },
            { path: '',     loadChildren:  loadEventSubmissionRoutes },
            // Fallback (unknown routes). Angular evaluates top → bottom, first match wins
            { path: '**', redirectTo: 'home'}
        ]
    }
];